import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAttentiveIntegration = {
  name: "getAttentiveIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    integration: z
      .object({
        _id: zExt.objectId(),
        team: zExt.objectId(),
        attentiveCompanyId: z.string(),
        attentiveCompanyName: z.string().optional(),
        accessToken: z.string(),
        events: z.array(z.string()),
        purposes: z.array(z.string()),
      })
      .optional(),
  }),
};
